import { Shader3D, ShaderFeatureType } from "../../RenderEngine/RenderShader/Shader3D";
import spineVertex from "../files/SpineVertex.glsl";
import spineFragment from "../files/SpineFragment.glsl";
import { LayaGL } from "../../layagl/LayaGL";
import { ShaderDataType } from "../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import spineStandardVS from "../files/SpineStandard.vs";
import spineStandardFS from "../files/SpineStandard.fs";
import { SubShader } from "../../RenderEngine/RenderShader/SubShader";
import { Laya } from "../../../Laya";
import { RenderState } from "../../RenderDriver/RenderModuleData/Design/RenderState";
import { VertexDeclaration } from "../../RenderEngine/VertexDeclaration";
import { VertexElement } from "../../renders/VertexElement";
import { VertexElementFormat } from "../../renders/VertexElementFormat";
import { SpineMeshUtils } from "../mesh/SpineMeshUtils";
export class SpineShaderInit {
    static SetSpineBlendMode(value, mat, premultipliedAlpha = true) {
        switch (value) {
            case 1:
                mat.blend = RenderState.BLEND_ENABLE_ALL;
                mat.blendSrc = RenderState.BLENDPARAM_SRC_ALPHA;
                mat.blendDst = RenderState.BLENDPARAM_ONE;
                break;
            case 3:
                mat.blend = RenderState.BLEND_ENABLE_SEPERATE;
                mat.blendSrcRGB = RenderState.BLENDPARAM_ONE;
                mat.blendSrcAlpha = RenderState.BLENDPARAM_ONE;
                mat.blendDstRGB = RenderState.BLENDPARAM_ONE_MINUS_SRC_COLOR;
                mat.blendDstAlpha = RenderState.BLENDPARAM_ONE;
                break;
            case 2:
                mat.blend = RenderState.BLEND_ENABLE_ALL;
                mat.blendSrc = RenderState.BLENDPARAM_DST_COLOR;
                mat.blendDst = RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA;
                break;
            default:
                mat.blend = RenderState.BLEND_ENABLE_ALL;
                mat.blendSrc = premultipliedAlpha ? RenderState.BLENDPARAM_ONE : RenderState.BLENDPARAM_SRC_ALPHA;
                mat.blendDst = RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA;
        }
    }
    static initSpineMaterial(mat) {
        mat.alphaTest = false;
        mat.depthWrite = false;
        mat.cull = RenderState.CULL_NONE;
        mat.blend = RenderState.BLEND_ENABLE_ALL;
        mat.blendSrc = RenderState.BLENDPARAM_SRC_ALPHA;
        mat.blendDst = RenderState.BLENDPARAM_ONE_MINUS_SRC_ALPHA;
        mat.depthTest = RenderState.DEPTHTEST_OFF;
    }
    static changeVertexDefine(shaderData, mesh) {
        let hasTwoColor = false;
        let vertexBuffers = mesh.vertexBuffers;
        for (let i = 0; i < vertexBuffers.length; i++) {
            let vertexBuffer = vertexBuffers[i];
            let vertexDeclaration = vertexBuffer.vertexDeclaration;
            let vertexElement = vertexDeclaration.getVertexElementByUsage(11);
            if (vertexElement) {
                hasTwoColor = true;
                break;
            }
        }
        if (hasTwoColor) {
            shaderData.addDefine(SpineShaderInit.SPINE_COLOR2);
        }
        else {
            shaderData.removeDefine(SpineShaderInit.SPINE_COLOR2);
        }
    }
    static init() {
        Shader3D.addInclude("SpineVertex.glsl", spineVertex);
        Shader3D.addInclude("SpineFragment.glsl", spineFragment);
        SpineShaderInit.BONEMAT = Shader3D.propertyNameToID("u_sBone");
        SpineShaderInit.SpineTexture = Shader3D.propertyNameToID("u_spineTexture");
        SpineShaderInit.SPINE_FAST = Shader3D.getDefineByName("SPINE_FAST");
        SpineShaderInit.SPINE_RB = Shader3D.getDefineByName("SPINE_RB");
        SpineShaderInit.SPINE_UV = Shader3D.getDefineByName("COLOR");
        SpineShaderInit.SPINE_COLOR = Shader3D.getDefineByName("UV");
        SpineShaderInit.SPINE_PREMULTIPLYALPHA = Shader3D.getDefineByName("PREMULTIPLYALPHA");
        SpineShaderInit.SIMPLE_SIMPLEANIMATORPARAMS = Shader3D.propertyNameToID("u_SimpleAnimatorParams");
        SpineShaderInit.SIMPLE_SIMPLEANIMATORTEXTURE = Shader3D.propertyNameToID("u_SimpleAnimatorTexture");
        SpineShaderInit.SIMPLE_SIMPLEANIMATORTEXTURESIZE = Shader3D.propertyNameToID("u_SimpleAnimatorTextureSize");
        SpineShaderInit.SPINE_SIMPLE = Shader3D.getDefineByName("SPINE_SIMPLE");
        SpineShaderInit.SPINE_GPU_INSTANCE = Shader3D.getDefineByName("GPU_INSTANCE");
        SpineShaderInit.SPINE_TWOCOLORTINT = Shader3D.getDefineByName("TWOCOLORTINT");
        SpineShaderInit.SPINE_COLOR2 = Shader3D.getDefineByName("COLOR2");
        const commandUniform = LayaGL.renderDeviceFactory.createGlobalUniformMap("Spine2D");
        commandUniform.addShaderUniform(SpineShaderInit.BONEMAT, "u_sBone", ShaderDataType.Buffer);
        commandUniform.addShaderUniform(SpineShaderInit.SIMPLE_SIMPLEANIMATORPARAMS, "u_SimpleAnimatorParams", ShaderDataType.Vector4);
        commandUniform.addShaderUniform(SpineShaderInit.SIMPLE_SIMPLEANIMATORTEXTURE, "u_SimpleAnimatorTexture", ShaderDataType.Texture2D);
        commandUniform.addShaderUniform(SpineShaderInit.SIMPLE_SIMPLEANIMATORTEXTURESIZE, "u_SimpleAnimatorTextureSize", ShaderDataType.Float);
        let shader = Shader3D.add("SpineStandard", true, false);
        shader.shaderType = ShaderFeatureType.D2_BaseRednerNode2D;
        let uniformMap = {
            "u_spineTexture": ShaderDataType.Texture2D
        };
        let subShader = new SubShader(SpineShaderInit.textureSpineAttribute, uniformMap);
        shader.addSubShader(subShader);
        let shadingPass = subShader.addShaderPass(spineStandardVS, spineStandardFS);
        SpineShaderInit.SpineNormalVertexDeclaration = SpineMeshUtils.getVertexDeclaration("UV,COLOR,POSITION,COLOR2");
        SpineShaderInit.instanceNMatrixDeclaration = new VertexDeclaration(24, [
            new VertexElement(0, VertexElementFormat.Vector3, 8),
            new VertexElement(12, VertexElementFormat.Vector3, 9),
        ]);
        SpineShaderInit.instanceSimpleAnimatorDeclaration = new VertexDeclaration(16, [
            new VertexElement(0, VertexElementFormat.Vector4, 10),
        ]);
    }
}
SpineShaderInit.textureSpineAttribute = {
    'a_uv': [0, ShaderDataType.Vector2],
    'a_color': [1, ShaderDataType.Vector4],
    'a_position': [2, ShaderDataType.Vector2],
    "a_weight": [3, ShaderDataType.Float],
    "a_BoneId": [4, ShaderDataType.Float],
    'a_PosWeightBoneID_2': [5, ShaderDataType.Vector4],
    'a_PosWeightBoneID_3': [6, ShaderDataType.Vector4],
    'a_PosWeightBoneID_4': [7, ShaderDataType.Vector4],
    'a_NMatrix_0': [8, ShaderDataType.Vector3],
    'a_NMatrix_1': [9, ShaderDataType.Vector3],
    'a_SimpleTextureParams': [10, ShaderDataType.Vector4],
    "a_color2": [11, ShaderDataType.Vector4],
};
Laya.addAfterInitCallback(SpineShaderInit.init);
